import '../../styles-new/pages/olympiad/medals.scss';
import generateTabs from '../components/generateTabs'

generateTabs('sidebar-last', { isLoadMore: false });

// Sorting dropdown functionality
const medalsSorting = () => {
  const sortingBtn = document.querySelector('.medals-sorting__btn');
  const sortingDropdown = document.querySelector('.medals-sorting__dropdown');
  const sortingText = document.querySelector('.medals-sorting__text');
  const sortingOptions = document.querySelectorAll('.medals-sorting__option');

  if (!sortingBtn || !sortingDropdown) return;

  // Toggle dropdown
  sortingBtn.addEventListener('click', (e) => {
    e.stopPropagation();
    sortingDropdown.classList.toggle('medals-sorting__dropdown--active');
    sortingBtn.classList.toggle('medals-sorting__btn--active');
  });

  // Handle option selection
  sortingOptions.forEach(option => {
    option.addEventListener('click', (e) => {
      e.stopPropagation();
      const sortValue = option.getAttribute('data-sort');
      const optionText = option.textContent;
      
      // Update button text
      sortingText.textContent = optionText;
      
      // Remove active class from all options
      sortingOptions.forEach(opt => opt.classList.remove('medals-sorting__option--active'));
      
      // Add active class to selected option
      option.classList.add('medals-sorting__option--active');
      
      // Close dropdown
      sortingDropdown.classList.remove('medals-sorting__dropdown--active');
      sortingBtn.classList.remove('medals-sorting__btn--active');
      
      // Here you can add sorting logic
      console.log('Sort by:', sortValue);
      // sortTable(sortValue);
    });
  });

  // Close dropdown when clicking outside
  document.addEventListener('click', (e) => {
    if (!e.target.closest('.medals-sorting')) {
      sortingDropdown.classList.remove('medals-sorting__dropdown--active');
      sortingBtn.classList.remove('medals-sorting__btn--active');
    }
  });
};

// Initialize sorting dropdown
medalsSorting();